import { cn } from "@lib/cn";
import { memo } from "react";

type CustomLegendItemProps = {
  label: string;
  color: string;
  Icon: React.ElementType;
  percentage: number;
  isHidden: boolean;
  onToggle: (name: string) => void;
};

export const CustomLegendItem = memo(
  ({
    label,
    color,
    Icon,
    percentage,
    isHidden,
    onToggle,
  }: CustomLegendItemProps) => {
    return (
      <button
        type="button"
        onClick={() => onToggle(label)}
        className={cn(
          "tw-bg-transparent tw-grid tw-w-full tw-cursor-pointer tw-select-none tw-grid-cols-[auto_auto] tw-items-center tw-gap-8 tw-border-0 tw-p-0 tw-text-left tw-transition-all tw-duration-300 -sm:tw-gap-4",
          isHidden && "tw-opacity-40",
        )}
      >
        <div className="tw-flex tw-items-center tw-gap-1">
          <span
            className="tw-mr-1 tw-block tw-size-3 tw-rounded-sm"
            style={{ backgroundColor: color }}
          />
          <Icon className="tw-size-4 tw-text-blue" />
          <span className="tw-whitespace-nowrap tw-font-sans tw-text-xs tw-font-normal tw-text-blue">
            {label}
          </span>
        </div>
        <span className="tw-ml-auto tw-font-sans tw-text-xs tw-font-semibold tw-text-blue-500">
          {percentage}%
        </span>
      </button>
    );
  },
);
